import React, { Component } from 'react'
import stickybits from 'stickybits'
import { withRouter } from 'react-router-dom'
import i18next, { t } from 'i18next'
import './index.css'

class Navigation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      active: 'intro',
      languageToggleOpen: false
    }
  }

  componentDidMount() {
    this.sticky = stickybits(this.refs.nav, {
      useStickyClasses: true
    })
    window.addEventListener('scroll', () => this.detectVisibleSection())

    if ((window.location.host.includes('.nl') || window.location.host.includes('.be')) && i18next.language !== 'nl') {
      this.changeLanguage('nl')
    } else if (window.location.host.includes('.de') && i18next.language !== 'de') {
      this.changeLanguage('de')
    } else if (window.location.host.includes('.com') && i18next.language !== 'en') {
      this.changeLanguage('en')
    }

    this.props.getContentFromCMS(i18next.language)

    setTimeout(() => this.setState({
      languageToggleOpen: false
    }), 300)
  }

  componentWillUnmount() {
    this.sticky.cleanup()
  }

  detectVisibleSection() {
    const { active } = this.state
    const construction = document.querySelector('.Construction').getBoundingClientRect().top
    const houses = document.querySelector('.Houses').getBoundingClientRect().top
    const contact = document.querySelector('.Contact').getBoundingClientRect().top

    if (construction > this.refs.nav.clientHeight && active !== 'intro') {
      this.setState({
        active: 'intro'
      })
    } else if (construction < this.refs.nav.clientHeight && houses > this.refs.nav.clientHeight && active !== 'construction') {
      this.setState({
        active: 'construction'
      })
    } else if (houses < this.refs.nav.clientHeight && contact > this.refs.nav.clientHeight && active !== 'houses') {
      this.setState({
        active: 'houses'
      })
    } else if (contact < this.refs.nav.clientHeight && active !== 'contact') {
      this.setState({
        active: 'contact'
      })
    }
  }

  changeLanguage(key) {
    this.setState({
      languageToggleOpen: !this.state.languageToggleOpen
    }, () => {
      i18next.changeLanguage(key)
      const url = key === 'nl' ? '/' : key
      window.history.pushState(null, null, url)
      this.props.getContentFromCMS(key)
    })
  }

  navScrollTo(component) {
    switch (component) {
      case 'intro':
        document.querySelector('.Hero').scrollIntoView({
          behavior: 'smooth'
        })
        break;

      case 'construction':
        document.querySelector('.Construction ').scrollIntoView({
          behavior: 'smooth'
        })
        break;

      case 'houses':
        document.querySelector('.Houses').scrollIntoView({
          behavior: 'smooth'
        })
        break;

      case 'contact':
        document.querySelector('.Contact').scrollIntoView({
          behavior: 'smooth'
        })
        break;

      default:
        console.warn('unkown component')
        break;
    }
  }

  render() {
    const { active, languageToggleOpen } = this.state

    const languages = [
      {
        key: 'nl',
        image: require('../../Assets/Images/Flags/netherlands.svg')
      },
      {
        key: 'de',
        image: require('../../Assets/Images/Flags/germany.svg')
      },
      {
        key: 'en',
        image: require('../../Assets/Images/Flags/united-kingdom.svg')
      }
    ]

    return (
      <nav ref="nav">
        <div class="wrapper">
          {window.innerWidth > 501 && <img src={require('../../Assets/Images/logo_bizon-prefab.svg')} alt="Bizon Prefab logo" />}
          {window.innerWidth < 500 && <img src={require('../../Assets/Images/logo_bizon-prefab--small.svg')} alt="Bizon Prefab logo" />}

          <div style={{ display: 'flex', alignItems: 'center' }}>
            {!languageToggleOpen && <div className="items">
              <div onClick={() => this.navScrollTo('intro')} className={active === 'intro' ? 'active' : ''}>{t('navigation.intro')}</div>
              <div onClick={() => this.navScrollTo('construction')} className={active === 'construction' ? 'active' : ''}>{t('navigation.construction')}</div>
              <div onClick={() => this.navScrollTo('houses')} className={active === 'houses' ? 'active' : ''}>{t('navigation.houses')}</div>
              <div onClick={() => this.navScrollTo('contact')} className={active === 'contact' ? 'active' : ''}>{t('navigation.contact')}</div>
            </div>}

            <div className={`Languages ${languageToggleOpen ? 'LanguagesOpen' : ''}`}>
              {languages.map((lang, i) => (
                <div key={`language-${i}`}
                  className={`language ${i18next.language === lang.key ? 'language--current' : ''}`}
                  style={{ backgroundImage: `url(${lang.image})` }}
                  onClick={() => this.changeLanguage(lang.key)} />
              ))}
            </div>
          </div>

        </div>
      </nav>
    )
  }
}

export default Navigation = withRouter(Navigation)


// WEBPACK FOOTER //
// ./src/Components/Navigation/index.js